import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "min-w-0" };
const _hoisted_2 = { class: "text-sm font-semibold text-(--colors-text-error-strong)" };
const _hoisted_3 = { class: "mt-2 flex flex-col gap-1" };
const _hoisted_4 = ["data-testid", "onClick"];
import { ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DonationSettingsErrorSummary',
    props: {
        tabs: {}
    },
    emits: ["select"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const emit = __emit;
        const root = ref(null);
        __expose({
            focus: () => root.value?.focus(),
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "root",
                ref: root,
                role: "alert",
                tabindex: "-1",
                class: "flex items-start gap-3 rounded-lg border border-(--colors-border-error-subtle) bg-(--colors-background-error) p-4 focus-visible:outline-2 focus-visible:outline-(--colors-border-error-strong)",
                "data-testid": "donation-settings-error-summary"
            }, [
                _cache[0] || (_cache[0] = _createElementVNode("i", {
                    class: "ri-error-warning-fill text-xl leading-5 text-(--colors-icon-error)",
                    "aria-hidden": "true"
                }, null, -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("finance.donationModuleSettings.errorSummary.title")), 1 /* TEXT */),
                    _createElementVNode("ul", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
                            return (_openBlock(), _createElementBlock("li", {
                                key: tab.key
                            }, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "cursor-pointer text-sm text-(--colors-text-link) underline underline-offset-2 hover:no-underline focus-visible:outline-2 focus-visible:outline-(--colors-border-accent)",
                                    "data-testid": `donation-settings-error-summary-${tab.key}`,
                                    onClick: ($event) => (emit('select', tab.key))
                                }, _toDisplayString(tab.label), 9 /* TEXT, PROPS */, _hoisted_4)
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ])
            ], 512 /* NEED_PATCH */));
        };
    }
});
